import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PersonalSummaryActions";
import * as api from "../../api/PersonalSummaryApi";
import { showSnackMessage } from "../actions/PersonalSummaryActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getPersonnelSummary(action) {
    yield put(resetBackdrop());
    try {
        const result = yield api.getPersonnelSummary(action.payload);
        yield put(actions.setPersonnelSummary(result));
    } catch (error) {
        yield put(showSnackMessage(error, "error"));
    }
    yield put(setBackdrop());
}

function* getList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showSnackMessage(error, "error"));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_PERSONNEL_SUMMARY, getPersonnelSummary);
    yield takeEvery(actions.Types.GET_POOL_LIST, getList);
}
const PersonalSummarySaga = [fork(watchAll)];

export default PersonalSummarySaga;
